import { jwtDecode } from 'jwt-decode';
import { forwardRef, useImperativeHandle } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Authentication } from '../services/internal/authentication';
import { fetchDataErrors, fetchDataFailure, fetchPermissions, loadUserInfo, removePermissions, removeToken, setShowRemoteResponseToast, setToken } from '../core/redux/action';
import { useNavigate } from 'react-router-dom';
import { all_routes } from './all_routes';
import { showInternalErrorAlert } from '../feature-module/components/customAlert';

const TokenRefresh = forwardRef((props, ref) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const token = useSelector((state) => state.token);
    const routes = all_routes;

    const validateToken = async (err) => {
        if (token) {
            let userData = jwtDecode(token);

            /*console.log(new Date(userData.exp * 1000))
            console.log(new Date())*/
            if (new Date().getTime() >= (userData.exp * 1000)) {
                try {
                    const response = await Authentication.postRefresh({ token: token });
                    if (response.data.success) {
                        let userInfo = jwtDecode(token);
                        Authentication.saveToken(response.data.data.token);
                        Authentication.savePermissions(response.data.data.rolePermisions);
                        dispatch(setToken(response.data.data.token));
                        dispatch(fetchPermissions(response.data.data.rolePermisions));
                        dispatch(loadUserInfo(userInfo));
                    } else {
                        dispatch(removeToken());
                        dispatch(setToken(null));
                        dispatch(fetchPermissions([]));
                        dispatch(removePermissions());
                        navigate(routes.home);
                    }
                }
                catch (err) {
                    console.log(err);
                    dispatch(removeToken());
                    dispatch(setToken(null));
                    dispatch(removePermissions());
                    dispatch(fetchPermissions([]));
                    navigate(routes.home);
                }
            } else {
                dispatch(loadUserInfo(userData));
            }
        } else {
            if (err) {
                dispatch(fetchDataErrors(err.response.data.errors));
                dispatch(setShowRemoteResponseToast(true));
            }
        }
    }

    const handleException = async (err) => {
        console.log(err);
        if (err.response) {
            dispatch(fetchDataFailure({ data: err.response.data, status: err.response.status, statusText: err.response.statusText }));
            if (err.response.status === 401) {
                await validateToken(err);
                return;
            }
            else if (err.response.status >= 400 && err.response.status < 500) {
                dispatch(fetchDataErrors(err.response.data.errors));
                dispatch(setShowRemoteResponseToast(true));
                return;
            } else {
                showInternalErrorAlert(false, err.response.statusText);
                return;
            }
        }
        dispatch(fetchDataFailure(err));
        showInternalErrorAlert(true, err.code);
    }

    // Exponemos la función al padre
    useImperativeHandle(ref, () => ({
        validateToken,
        handleException,
    }));

    return null;
});

TokenRefresh.displayName = 'TokenRefresh';

export default TokenRefresh;